export default __webpack_public_path__ + "static/media/hackamon.42ba7aa3.png";